import React, { useState, useEffect } from "react"
import { useAppCtx, appStore } from "lib/state"
import { Modal } from "lib/components"
import { queryTools, cn } from "lib/utils"
import { Forms } from "lib/components/forms"
import { useConditional } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"


export default function SaveConditionalModal(){

  const { appState }:any = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { closeModal } = useConditional()

  const { currentConditional, updateConditional }:any = useConditionalCtx()

  const { update }:any = AppStore

  const { data:_Conditionals } = queryTools.resource.parseQueryForApi("conditional.findAll", {})
  const saveNewFn = queryTools.resource.save(["conditional.all"])
  const saveExistingFn = queryTools.resource.save(['conditional.all', `conditional.single.${currentConditional?.source_id}`])

  const [ foundConditional, setFoundConditional ] = useState<any>(null)
  const [ saveChoice, setSaveChoice ] = useState<any>("create")
  const [ conditionalData, setConditionalData ] = useState<any>({ name: "", description: ""})

  const handleInputChange = (e:any) => setConditionalData({ ...conditionalData, [e.target.name]: e.target.value })

  const updateSourceId = (newSourceId:string) => {
    updateConditional({ ...currentConditional, source_id: newSourceId })
  }

  const handleFormSubmit = (e:any) => {
    e.preventDefault()
    console.log(currentConditional.source_id)
    console.log(conditionalData)
    let submitData

    if( saveChoice === "create" ){
      submitData = { ...currentConditional, ...conditionalData, source_id: undefined, _id: undefined }
      saveNewFn.mutate({ resource: "conditional", data: submitData }, { onSuccess: (data:any) => console.log(data) })
    } else {
      submitData = { ...currentConditional, ...conditionalData, _id: currentConditional.source_id }
      saveNewFn.mutate({ resource: "conditional", data: submitData  }, { onSuccess: (data:any) => console.log(data) })
    }

    closeModal()
  }

  useEffect(() => {
    const found = _Conditionals?.find( (item:any) => item._id === currentConditional?.source_id )
    if( found ){
      setFoundConditional(found)
      setConditionalData({ name: found.name, description: found.description })
    }
  },[_Conditionals])

  return (
    <Modal
      size="lg"
      title="Save Conditional:" 
      status={store.metas.conditionalModal === "save-conditional" ? "open" : "closed"}
        onClose={closeModal}
    >
      <div className="w-full mx-auto flex flex-col items-center gap-4">
          <div className="w-full flex flex-col justify-center items-center gap-4 text-center">

            { foundConditional !== null && (
              <div className="w-full flex flex-col">
                <p>This original source for this conditional already<br/>exists in the database. You can:</p>

                <div className="w-[90%] mx-auto flex justify-center items-center gap-2">
                  <div 
                    onClick={() => setSaveChoice("replace")}
                    className={cn(
                      "w-6/12 py-1 flex justify-center items-center cursor-pointer border border-solid border-slate-700",
                      saveChoice === "replace" && "bg-green-700"
                    )}
                  >
                    replace existing
                  </div>
                  <div 
                    onClick={() => setSaveChoice("create")}
                    className={cn(
                      "w-6/12 py-1 flex justify-center items-center cursor-pointer border border-solid border-slate-700",
                      saveChoice === "create" && "bg-green-700"
                    )}
                  >
                    create new
                  </div>
                </div>
              </div>
            )}

            <div className="w-full gap-2">
              <Forms.Form className="flex flex-col" onSubmit={handleFormSubmit}>
                <Forms.FieldGroup name="name" label="Name" type="text">
                  <Forms.InputField name="name" value={conditionalData.name} onChange={handleInputChange} />
                </Forms.FieldGroup>

                <Forms.FieldGroup name="description" label="Description" type="text">
                  <Forms.Textarea name="description" value={conditionalData.description} onChange={handleInputChange} />
                </Forms.FieldGroup>

                <div className="w-full flex flex-row justify-end items-center pr-1">
                  <Forms.FormButton type="submit" className="w-4/12 flex justify-center items-center p-0" onClick={() => console.log("save")} label="Save">Save</Forms.FormButton>
                </div>
              </Forms.Form>

            </div>

          </div>
    
      </div>
    </Modal>
  )
}